package com.upcominds.expedite.data.rewards

import com.upcominds.expedite.data.NetworkClient
import com.upcominds.expedite.dto.RedeemRewardResultDTO
import com.upcominds.expedite.dto.RewardCatalogDTO
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.post
import io.ktor.http.ContentType
import io.ktor.http.contentType

class RewardsRepositoryImpl : RewardsRepository {
    private val httpClient: HttpClient = NetworkClient.httpClient

    override suspend fun getCatalog(): RewardCatalogDTO {
        return httpClient.get(NetworkClient.endpoint("api/rewards")).body<RewardCatalogDTO>()
    }

    override suspend fun redeemReward(rewardId: String): RedeemRewardResultDTO {
        return httpClient.post(NetworkClient.endpoint("api/rewards/$rewardId/redeem")) {
            contentType(ContentType.Application.Json)
        }.body<RedeemRewardResultDTO>()
    }
}
